<template>
  <div class="dashboard">
    <div class="page-bar hide">
      <ul class="page-breadcrumb">
        <li>
          <i class="icon-home"></i>
          <router-link to="/workspace/">Workspace</router-link>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <span>Public files</span>
        </li>
      </ul>
      <div class="page-toolbar hide">
        <div class="btn-group pull-right">
          <button type="button" class="btn btn-fit-height grey-salt dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-delay="1000" data-close-others="true" aria-expanded="false"> Widgets
            <i class="fa fa-angle-down"></i>
          </button>
          <ul class="dropdown-menu pull-right module-zone" role="menu">

          </ul>
        </div>
      </div>
    </div>
    <breadcrumb-bar :crumbs="['Public files']"></breadcrumb-bar>
    <div class="row">
      <div class="col-md-12">
        <div class="portlet light">

          <div class="portlet-title">
            <div class="caption caption-md">
              <span class="caption-subject bold uppercase">Public files</span>
            </div>
          </div>

          <div class="portlet-body">
            <template v-if="user.access >= 4">
            <div class="upload">
              <button class="btn green upload-button">Add Files</button>
              <input type="file" id="file" ref="files" multiple v-on:change="handleFilesUpload()">
            </div>
            <button id="start-upload" class="btn green mt-ladda-btn ladda-button" data-style="expand-left" @click.prevent="submitFiles()" :disabled="this.fileList == ''">
              <span class="ladda-label">Upload Files</span>
            </button>
            </template>

            <div v-if="this.fileList != ''">
              <span><strong>Files: </strong>{{ fileList }}</span>
            </div>

            <div class="files-table" v-if="totalRecords > 0 || serverParams.columnFilters != {}">
              <vue-good-table
                  :columns="columns"
                  :rows="publicFiles"
                  :pagination-options="{
                      enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage
                      }"
                  mode="remote"
                  :totalRows="totalRecords"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :isLoading="isLoading"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field=='deleted'">{{ props.row.deleted ? 'Deleted' : 'Published' }}</span>
                  <span v-else-if="props.column.field=='date_attached'">{{ props.row.date_attached.date | formatDateModalNoTimeZone }} </span>
                  <span v-else-if="props.column.field=='public_url'"><a @click.prevent="copyUrl(getFileUrl(props.row.public_url))" :href="getFileUrl(props.row.public_url)">{{ props.row.public_url }}</a></span>
                  <div v-else-if="props.column.field=='actions'" class="last-dropdown">
                    <actions-menu>
                      <actions-menu-item
                        v-if="user.access >= 3"
                        title="Download"
                        icon="fa-download"
                        :href="getFileUrl(props.row.public_url)"
                      />
                      <actions-menu-item
                        v-if="user.access >= 4"
                        title="Edit description"
                        icon="fa-pencil-square-o"
                        @click.prevent="editDescription(props.row.description, props.row.id)"
                      />
                      <actions-menu-item
                        v-if="user.access >= 4 && props.row.deleted"
                        title="Restore"
                        icon="fa-upload"
                        @click.prevent="restore(props.row.id)"
                      />
                      <actions-menu-item
                        v-if="user.access >= 4 && !props.row.deleted"
                        title="Delete"
                        icon="fa-trash"
                        @click.prevent="deleteFileModal(props.row.id)"
                      />
                    </actions-menu>
                  </div>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
                <template slot="loadingContent">
                  <vue-spinner></vue-spinner>
                </template>
              </vue-good-table>
            </div>
            <div class="not-found-results" v-else>
              <h4>File list is empty.</h4>
            </div>
            <button v-if="serverParams.showDeleted && user.access >= 4" class="btn default" @click.prevent="hideDeleted()">Hide Deleted Files</button>
            <button v-else-if="user.access >= 4" class="btn default" @click.prevent="showDeleted()">Show Deleted Files</button>
          </div>
        </div>
      </div>
    </div>

    <div id="edit-description-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">Edit description</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <vue-spinner v-if="updatingDescription"></vue-spinner>
                <div v-else class="form-group">
                  <label for="public-file-description">Description</label>
                  <input type="text" class="form-control" id="public-file-description" placeholder="" v-model="newDescription">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green" @click.prevent="saveDescription()">Save</button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div id="delete-file-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">Delete file</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <vue-spinner v-if="deletingFile"></vue-spinner>
                <span v-else>Are you sure you want to delete file: <br/><strong>{{ selectedFile !== undefined ? selectedFile.original_filename : ''}}</strong> </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green" @click.prevent="deleteFile()">Yes</button>
            <button class="btn default" data-dismiss="modal">No</button>
          </div>
        </div>
      </div>
    </div>

    <input type="text" style="position: absolute; left: -9999px" value="" id="copy-url-input">

  </div>

</template>

<script>
  import {HTTP, ERROR, updateUserInfo, URL} from '@/http-common';
  import VueUploadComponent from 'vue-upload-component';
  import draggable from 'vuedraggable';
  import Widget from '@/components/widgets/Widget.vue';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import {mapActions, mapGetters} from 'vuex';
  import _ from 'lodash';
  import Spinner from '@/components/Spinner';
  import ActionsMenuItem from "../components/reusables/ActionsMenuItem";
  import ActionsMenu from "../components/reusables/ActionsMenu";

  export default {
    name: 'WorkspacePublicFiles',
    components: {
      draggable,
      widget: Widget,
      ActionsMenu,
      ActionsMenuItem,
      'breadcrumb-bar': Breadcrumbs,
      'file-upload': VueUploadComponent,
      'vue-spinner': Spinner
    },
    data() {
      return {
        columns: [
          {
            label: 'Name',
            field: 'original_filename',
            filterOptions: {enabled: true}
          },
          {
            label: 'Public URL',
            field: 'public_url',
            filterOptions: {enabled: true}
          },

          {
            label: 'Description',
            field: 'description',
            filterOptions: {enabled: true}
          },
          {
            label: 'Attached By',
            field: 'username',
            filterOptions: {enabled: true}
          },
          {
            label: 'Date Attached',
            field: 'date_attached',
            filterOptions: {enabled: true}
          },
          {
            label: 'Status',
            field: 'deleted',
            filterOptions: {enabled: true}
          },
          {
            label: 'Actions',
            field: 'actions',
            filterOptions: {enabled: false},
            sortable: false
          },
        ],
        files: '',
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
          showDeleted: false
        },
        selectedFileId: 0,
        newDescription: '',
        updatingDescription: false,
        deletingFile: false
      }
    },
    mounted() {
      this.loadPublicFiles(this.serverParams);

      let editDescriptionModal = $('#edit-description-modal');
      editDescriptionModal.on('hidden.bs.modal', () => {
        this.newDescription = '';
        this.selectedFileId = 0;
      });

      let deleteFileModal = $('#delete-file-modal');
      deleteFileModal.on('hidden.bs.modal', () => {
        this.selectedFileId = 0;
      });

    },
    computed: {
      ...mapGetters({
        publicFiles: 'getWorkspacePublicFiles',
        totalRecords: 'getWorkspacePublicFilesCount',
        user: 'getUser',
        isLoading: 'getWorkspaceLoading'
      }),
      fileList: function () {
        return _.map(this.files, 'name').join(', ')
      },
      selectedFile: function() {
        return _.find(this.publicFiles, (item) => {
          return item.id === this.selectedFileId;
        })
      }
    },
    methods: {
      ...mapActions({
        loadPublicFiles: 'loadWorkspacePublicFiles'
      }),
      getFilesList() {
        return this.loadPublicFiles(this.serverParams);
      },
      handleFilesUpload() {
        this.files = this.$refs.files.files;
      },
      submitFiles() {
        let l = Ladda.create(document.querySelector('#start-upload'));
        l.start();
        let formData = new FormData();
        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          formData.append('files[' + i + ']', file);
        }

        let self = this;

        HTTP.post('/workspace/public-files/upload/', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
          l.stop();
          if (response.data.status === 'success') {
            self.loadPublicFiles();
            self.files = '';
          }

        }).catch(function (error) {
          console.log(error);
          console.log('Something went wrong.');
          l.stop();
        });

      },
      deleteFile() {
        this.deletingFile = true;
        HTTP.post('/workspace/public-files/delete/' + this.selectedFileId).then((response) => {
          if (response.data.status === 'success') {
            this.getFilesList();
          }
        }).catch(function (error) {
          console.log(error);
        });
        $('#delete-file-modal').modal('hide');
        this.selectedFileId = 0;
        this.deletingFile = false;
      },
      restore(id) {
        HTTP.post('/workspace/public-files/publish/' +id).then((response) => {
          if (response.data.status === 'success') {
            this.getFilesList();
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      getFileUrl(publicUrl) {
        return URL + '/public-files/' + publicUrl;
      },
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.getFilesList();
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage, page: 1});
        this.getFilesList();
      },
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field
          },
        });
        this.getFilesList();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.getFilesList();
      },
      showDeleted() {
        this.updateParams({showDeleted: true});
        this.getFilesList();
      },
      hideDeleted() {
        this.updateParams({showDeleted: false});
        this.getFilesList();
      },
      deleteFileModal(id) {
        this.selectedFileId = id;
        $('#delete-file-modal').modal('show');
      },
      editDescription(description, id) {
        this.newDescription = description;
        this.selectedFileId = id;
        $('#edit-description-modal').modal('show')
      },
      saveDescription() {
        this.updatingDescription = true;
        HTTP.post('/workspace/public-files/update-description/' + this.selectedFileId, {
          'description': this.newDescription
        }).then((response) => {
          if (response.data.status === 'success') {
            this.getFilesList();
          }
          $('#edit-description-modal').modal('hide');
          this.updatingDescription = false;
        }).then((error) => {
          $('#edit-description-modal').modal('hide');
          this.updatingDescription = false;
        });
      },
      copyUrl(url) {
        $('#copy-url-input').val(url);
        let urlInput = document.querySelector('#copy-url-input');
        urlInput.select();
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        this.$notify('URL has been copied to clipboard!');
      }
    },
  }
</script>

<style scoped>

  .upload {
    width: 100px;
    height: 34px;
    position: relative;
    float: left;
    margin-right: 5px;
  }

  .upload button {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .upload input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }

  .last-dropdown {
    width: 155px;
  }

  .dropdown-menu {
    min-width: initial;
  }

  .files-table {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media (max-width: 767px) {
    .vgt-table-responsive .dropdown-menu {
      position: static !important;
    }

    .dropdown-backdrop {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// PublicFiles.vue?3dc5c88b